(function () {
    'use strict';
    radaCalculatorController.$inject = ['calculatorService'];
    angular 
        .module("app.calculator")
        .component("radaCalculator", {
            controller: radaCalculatorController,
            bindings: { 
                currency: '@',
                gasDescription: '@',
                electricDescription: '@',
                products: '@',
                gridElectricity: '@',
                heatOneLitreOfWaterByThirtyDegrees: '@',
                naturalGas: '@',
                locale: '@',
                pageId: '@',
                swimmingPool: '@',
                kettle: '@',
                familyCar: '@', 
                submissionText: '@',
                min: '@',
                waterCostSaved: '@',
                weeks: '@',
                description: '@',
                mainsWaterCost: '@',
                usesPerDay: '@',
                kettles: '@',
                savingsEquatesTo: '@',
                electricCostSaved: '@',
                emailPlaceholder: '@',
                viewThisProduct: '@',
                calculatedCurrentAnnualExpenditure: '@',
                familyCarsDescription: '@',
                swimmingPools: '@',
                greenhouseEmissions: '@',
                flowRate: '@',
                gasUsage: '@',
                yourCurrentUsage: '@',
                weeksOpenPerYear: '@',
                radaProducts: '@',
                yr: '@',
                emailLabel: '@',
                optInLabel: '@',
                waterUsage: '@',
                electricUsageSaved: '@',
                electricCost: '@',
                yourUnitCosts: '@',
                electricOrGasSupply: '@',
                numberOfOutlets: '@',
                waterUsageSaved: '@',
                kettlesDescription: '@',
                wasteWaterCost: '@',
                familyCars: '@',
                emissionsReduction: '@',
                numberOfOutletsDescription: '@',
                swimmingPoolsDescription: '@',
                totalSavings: '@',
                electric: '@',
                unitCostGas: '@',
                litres: '@',
                gasUsageSaved: '@',
                showerFlowRate: '@',
                unitCostElectric: '@',
                gas: '@',
                gasCostSaved: '@',
                gasCost:'@',
                averageShowerTime: '@',
                waterCost: '@',
                electricUsage: '@',
                mins: '@',
                send: '@',
                changeProduct: '@',
                product: '@',
                productIds: '@'


            }, // components are limited to isolated scope
            templateUrl: "/client/app/calculator/calculator.html",
            controllerAs: 'vm'
        });

    /* @ngInject */
    function radaCalculatorController(calculatorService) { 

        var vm = this;
      
        vm.switchingProducts = false;
        vm.computeAnnualExpenditure = computeAnnualExpenditure;
        vm.isValidHelper = isValidHelper;
        vm.isInvalidHelper = isInvalidHelper;
        vm.submit = submit;
        vm.changeProductSelection = changeProductSelection;
        vm.calculateTotalSavingsByProduct = calculateTotalSavingsByProduct;
        vm.setSupply = setSupply;
        vm.submitted = false;
        vm.switchProduct = switchProduct;

        vm.$onInit=function() {
            
            vm.model = {
                "mainsWaterCost" : 0.87,
                "wasteWaterCost" : 0.94,
                "supply" : "Electric",
                "unitCostGas": 0.037,
                "unitCostElectric" :0.12,
                "numberOfOutlets": 10,
                "usesPerDay": 10,
                "averageShowerTime": 10,
                "showerFlowRate": 12,
                "weeksOpenPerYear": 52,
                "waterUsage": 0,
                "waterCost": 0,
                "electricCost": 0,
                "utilityUsage": 0,
                "gasCost": 0,
                "greenhouseEmissions": 0,
                "waterUsageSavings": 0,
                "waterCostSavings": 0,
                "gasCostSavings": 0,
                "electricCostSavings": 0,
                "utilityUsageSavings": 0,
                "emissionsReduction": 0,
                "totalAnnualSavings": 0,
                "email":"",
                "consent": false,
                "swimmingPoolEquivalent": 0,
                "kettleEquivalent": 0,
                "familyCarEquivalent": 0,
                "locale": vm.locale
                }
        
            calculatorService.getProducts(vm.pageId, vm.productIds).then(function(resp) {
                if (resp) {
                    vm.products = resp;
                    vm.model.product = vm.products[0];
                    vm.model.productFlowRate = vm.products[0].flowRate;
                    vm.computeAnnualExpenditure();
                }
            });
           
        };
      
        function isValidHelper(field) {
            var required = field.$validators.required !== undefined;

            return (field.$valid && field.$pristine && required) ||
                (field.$valid && field.$dirty) ||
                (field.$valid && field.$touched) || (field.$valid && vm.submitted);
        }

        function isInvalidHelper(field) {
            return (field.$invalid && field.$dirty) ||  (field.$invalid && field.$touched) ||
                (field.$invalid && vm.submitted);
        }

        function waterCost(unitPrice, waterUsage) {
            return (unitPrice * waterUsage)/1000;
        }

        function emissions(waterUsage, heatOneLitreOfWaterByThirtyDegrees, carbonCost) {
            return waterUsage * heatOneLitreOfWaterByThirtyDegrees * carbonCost;
        }

        function utilityCost(unitCost, heatOneLitreOfWaterByThirtyDegrees, waterUsage) {
            return unitCost * heatOneLitreOfWaterByThirtyDegrees * waterUsage;
        }

        function utilityUsage(heatOneLitreOfWaterByThirtyDegrees, waterUsage) {
            return heatOneLitreOfWaterByThirtyDegrees * waterUsage;
        }
        
        function waterUsage(flowRate) {
            return vm.model.numberOfOutlets * vm.model.usesPerDay * vm.model.averageShowerTime * flowRate * vm.model.weeksOpenPerYear * 7;
        }

        function setSupply(supply) {
            vm.model.supply = supply;
            computeAnnualExpenditure();
        }
        
        function computeAnnualExpenditure() {
            //Usage & Cost
            vm.model.waterUsage = waterUsage(vm.model.showerFlowRate);
            vm.model.waterCost = waterCost(vm.model.mainsWaterCost, vm.model.waterUsage) + waterCost(vm.model.wasteWaterCost,vm.model.waterUsage);
            vm.model.electricCost = utilityCost(vm.model.unitCostElectric, vm.heatOneLitreOfWaterByThirtyDegrees, vm.model.waterUsage);
            vm.model.gasCost = utilityCost(vm.model.unitCostGas, vm.heatOneLitreOfWaterByThirtyDegrees, vm.model.waterUsage);

            vm.model.utilityUsage = utilityUsage(vm.heatOneLitreOfWaterByThirtyDegrees, vm.model.waterUsage);

            //Emissions
            if (vm.model.supply==="Electric") {
                vm.model.greenhouseEmissions = emissions(vm.model.waterUsage, vm.heatOneLitreOfWaterByThirtyDegrees, vm.gridElectricity);
            }
            else {
                vm.model.greenhouseEmissions =  emissions(vm.model.waterUsage, vm.heatOneLitreOfWaterByThirtyDegrees, vm.naturalGas);
            }

            //Water Savings 
            vm.model.waterUsageSavings = waterUsage(vm.model.showerFlowRate) - waterUsage(vm.model.product.flowRate);
            vm.model.waterCostSavings = ((vm.model.waterUsageSavings * vm.model.mainsWaterCost) + (vm.model.waterUsageSavings * vm.model.wasteWaterCost) )/1000;
           
            //Utility savings
            vm.model.gasCostSavings =utilityCost(vm.model.unitCostGas, vm.heatOneLitreOfWaterByThirtyDegrees, vm.model.waterUsage) - utilityCost(vm.model.unitCostGas, vm.heatOneLitreOfWaterByThirtyDegrees, (vm.model.waterUsage-vm.model.waterUsageSavings));
            vm.model.electricCostSavings =utilityCost(vm.model.unitCostElectric, vm.heatOneLitreOfWaterByThirtyDegrees, vm.model.waterUsage) - utilityCost(vm.model.unitCostElectric, vm.heatOneLitreOfWaterByThirtyDegrees, (vm.model.waterUsage-vm.model.waterUsageSavings));
           
            vm.model.utilityUsageSavings = utilityUsage(vm.heatOneLitreOfWaterByThirtyDegrees, vm.model.waterUsage) - utilityUsage(vm.heatOneLitreOfWaterByThirtyDegrees, (vm.model.waterUsage-vm.model.waterUsageSavings));


            if (vm.model.supply==="Electric") {
                vm.model.totalAnnualSavings = vm.model.waterCostSavings + vm.model.electricCostSavings;

                vm.model.emissionsReduction = emissions(vm.model.waterUsage, vm.heatOneLitreOfWaterByThirtyDegrees, vm.gridElectricity) 
                                            -emissions((vm.model.waterUsage-vm.model.waterUsageSavings), vm.heatOneLitreOfWaterByThirtyDegrees, vm.gridElectricity);
            }
            else {
                vm.model.totalAnnualSavings = vm.model.waterCostSavings + vm.model.gasCostSavings;

                vm.model.emissionsReduction = emissions(vm.model.waterUsage , vm.heatOneLitreOfWaterByThirtyDegrees , vm.naturalGas) 
                                            -emissions((vm.model.waterUsage-vm.model.waterUsageSavings) , vm.heatOneLitreOfWaterByThirtyDegrees, vm.naturalGas);
            }

            //equivalents
            vm.model.swimmingPoolEquivalent = vm.model.waterUsageSavings / vm.swimmingPool;
            vm.model.kettleEquivalent = vm.model.utilityUsageSavings / vm.kettle;
            vm.model.familyCarEquivalent = vm.model.emissionsReduction / vm.familyCar;
 
        }

        function submit() {
            calculatorService.createFormRecord(vm.model).then(function ()
            {
             
               vm.submitted = true}
            );
        }

        function changeProductSelection(product) {
            vm.model.product = product;
            vm.switchingProducts = false;
            computeAnnualExpenditure();
        }

        function switchProduct() {
            vm.switchingProducts = true;
        }

        function calculateTotalSavingsByProduct(product) {
            var waterUsageSavings = waterUsage(vm.model.showerFlowRate) - waterUsage(product.flowRate);
            var waterCostSavings = ((waterUsageSavings * vm.model.mainsWaterCost) + (waterUsageSavings * vm.model.wasteWaterCost) )/1000;

            var gasCostSavings = vm.model.gasCost - utilityCost(vm.model.unitCostGas, vm.heatOneLitreOfWaterByThirtyDegrees, (vm.model.waterUsage-waterUsageSavings));
            var electricCostSavings = vm.model.electricCost - utilityCost(vm.model.unitCostElectric, vm.heatOneLitreOfWaterByThirtyDegrees, (vm.model.waterUsage-waterUsageSavings));
            
            if (vm.model.supply==="Electric") {
                return (waterCostSavings + electricCostSavings);
            }
            else {
                return (waterCostSavings + gasCostSavings);
            }
        }
    }
})();